import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { PrintExportQuoteComponent } from '../quote/print-export-quote/print-export-quote.component';
import { QuoteVersion } from '../entities/quoteVersion.entity';

@Component({
  selector: 'app-quote-restore',
  templateUrl: './quote-restore.component.html',
  styleUrls: ['./quote-restore.component.scss'],
  standalone: false
})
export class QuoteRestoreComponent implements OnInit {
  restoreQuoteText: string;
  appStrings: AppLocalization;
  selections;
  radioValues: any;
  element: QuoteVersion;
  restoreQuoteForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<PrintExportQuoteComponent>,
    private appInfoService: AppInfoService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.element = data.quote;
    this.initForm();
  }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.radioValues = [
      { label: this.appStrings.quote_restoreSelectedAndSaveCurrent, value: '1' },
      { label: this.appStrings.quote_discardSelectedAndSaveCurrent, value: '2' }
    ];
    this.selections = {
      discardCurrentAndRestoreSelected: false,
      restoreSelectedAndSaveCurrent: false
    };

    this.restoreQuoteText = this.appStrings.quote_restoreQuoteTitle
      .replace('{0}', this.element.quoteRevisionNumber);
  }

  close(sendSelections?): void {
    this.dialogRef.close(sendSelections ? this.selections : null);
  }

  confirmSelection() {
    const selectedValue = this.restoreQuoteForm.value.option;
    if (selectedValue === '1') {
      this.selections.restoreSelectedAndSaveCurrent = true;
    } else {
      this.selections.discardCurrentAndRestoreSelected = true;
    }
    this.close(true);
  }

  private initForm() {
    this.restoreQuoteForm = this.fb.group({
      option: ['1']
    });
  }

}
